import { initializeApp } from "firebase/app";
import { getDatabase,ref, onValue,set } from "firebase/database";
import { GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {

    apiKey: "AIzaSyCfm5yuqQ1Iyo-ZlR2ZvVVzGnqagxhA1yI",
  
    authDomain: "testapp-e32e9.firebaseapp.com",
  
    databaseURL: "https://testapp-e32e9-default-rtdb.firebaseio.com",
  
    projectId: "testapp-e32e9",
  
    storageBucket: "testapp-e32e9.appspot.com",
  
    messagingSenderId: "788767552264",
  
    appId: "1:788767552264:web:0e2f707b42417feaf772bd",
  
    measurementId: "G-E80JYC7R7N"
  
  };
  

// Initialize Firebase
export const app = initializeApp(firebaseConfig);


export const provider = new GoogleAuthProvider();
